module.exports = __webpack_public_path__ + "static/media/puzzle-piece.9218bede.png";